import { createReducer, on } from '@ngrx/store';

import { PagedBase } from '../general/models/general';
import { IMyTask } from '../mytasks/models/MyTasks';
import { ILibraryData,Library } from './models/Library';
import {
  IRiskCompliance,
  Risks,
  RisksFromVulnerability,
  RisksTasks,
} from './models/Risks';
import * as actions from './risks.actions';

export const RISKS_FEATURE_KEY = 'risks';

export interface RisksState extends PagedBase {
  risksRegister: Risks[];
  riskRegisterById: Risks;
  riskLibraryById: Library;
  risksLibrary: Risks[];
  isLoading: boolean;
  isRiskVulnerabilitiesLoading: boolean;
  isRiskTasksLoading: boolean;
  riskState: boolean;
  riskVulnerabilityById: RisksFromVulnerability[];
  riskTasksById: RisksTasks[];
  myTasks: IMyTask[];
  risksLibraryData: ILibraryData[];
  riskComplianceById: IRiskCompliance;
}

export const initialState: RisksState = {
  risksRegister: [],
  riskRegisterById: null,
  riskLibraryById: null,
  risksLibrary: [],
  isLoading: false,
  isRiskVulnerabilitiesLoading: false,
  isRiskTasksLoading: false,
  riskState: false,
  riskVulnerabilityById: [],
  riskTasksById: [],
  myTasks: [],
  risksLibraryData: [],
  riskComplianceById: null,
  hasMore: false,
  pageNumber: 1,
  pageSize: 0,
  totalCount: undefined,
  totalPages: 0,
};

export const risksReducer = createReducer(
  initialState,
  on(actions.getRisksRegister, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getRisksRegisterSuccess,
    (state, { pagedRisksRegister: { items, ...rest } }) => ({
      ...state,
      ...rest,
      risksRegister:
        rest.pageNumber === 1 ? [...items] : [...state.risksRegister, ...items],
      isLoading: false,
    }),
  ),
  on(actions.getRisksRegisterById, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getRisksRegisterByIdSuccess, (state, { riskRegisterById }) => ({
    ...state,
    riskRegisterById,
    isLoading: false,
  })),
  on(actions.getRiskVulnerabilityById, (state) => ({
    ...state,
    isRiskVulnerabilitiesLoading: true,
  })),
  on(
    actions.getRiskVulnerabilityByIdSuccess,
    (state, { pagedRiskVulnerabilityById: { items, ...rest } }) => ({
      ...state,
      ...rest,
      riskVulnerabilityById:
        rest.pageNumber === 1
          ? [...items]
          : [...state.riskVulnerabilityById, ...items],
      isRiskVulnerabilitiesLoading: false,
    }),
  ),
  on(actions.getRiskTasksById, (state) => ({
    ...state,
    isRiskTasksLoading: true,
  })),
  on(
    actions.getRiskTasksByIdSuccess,
    (state, { pagedRiskTasksById: { items, ...rest } }) => ({
      ...state,
      ...rest,
      riskTasksById:
        rest.pageNumber === 1 ? [...items] : [...state.riskTasksById, ...items],
    }),
  ),
  on(actions.getRisksLibrary, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getRisksLibrarySuccess,
    (state, { pagedRisksLibrary: { items, ...rest } }) => ({
      ...state,
      ...rest,
      risksLibrary:
        rest.pageNumber === 1 ? [...items] : [...state.risksLibrary, ...items],
      isLoading: false,
    }),
  ),
  on(actions.getRisksLibraryById, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getRisksLibraryByIdSuccess, (state, { riskLibraryById }) => ({
    ...state,
    riskLibraryById,
    isLoading: false,
  })),
  on(actions.updateRiskRegister, (state) => ({
    ...state,
  })),
  on(actions.updateRiskRegisterSuccess, (state, { riskId, newBody }) => {
    return {
      ...state,
      risksRegister: state.risksRegister
        ? state.risksRegister.map((risk) =>
            risk.id === riskId ? { ...risk, ...newBody } : risk,
          )
        : [],
    };
  }),
  on(actions.deleteRiskRegisterSuccess, (state, { riskId }) => ({
    ...state,
    risksRegister: state.risksRegister.filter((report) => report.id !== riskId),
    isLoading: false,
  })),
  on(actions.clearRiskRegister, (state) => ({
    ...state,
    riskRegisterById: null as Risks,
  })),
  on(
    actions.getRisksLibraryDataSuccess,
    (state, { pagedRisksLibraryData: { items, ...rest } }) => ({
      ...state,
      ...rest,
      risksLibraryData:
        rest.pageNumber === 1
          ? [...items]
          : [...state.risksLibraryData, ...items],
      isLoading: false,
    }),
  ),
  on(actions.getRisksComplianceById, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getRisksComplianceByIdSuccess,
    (state, { riskComplianceById }) => ({
      ...state,
      riskComplianceById,
      isLoading: false,
    }),
  ),
);
